import React, { useContext } from "react";
import { Icon, IconButton, PrimaryButton, TooltipHost } from "@fluentui/react";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../context/theme/ThemeContext";
import { t } from "i18next";
import { capitalizeFullName } from "../StudyList/helpers/helpingFunctions";
import { cancelIconButtonStyles, getStatusIcon, iconButtonStyles } from "./Helper";

const ColumnsPacsQueue = (handleRefreshQueueItem, handleCancelQueueItem, handlePriorityUp, handlePriorityDown) => {

  let widthStyle = 'calc((100vw - 200px) / 12)';
  let paddingChild = '15px 0px 15px 10px';

  return [
    {
      id: "id",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Job Id</span>,
      accessor: "id",
      accessorKey: "id",
      show: true,
      cell: (cell) => {
        return (
          <div className="user-sub-heading">
            <div style={{marginRight:'5px'}}> {cell.row.original.id} </div>
            <div><IconButton
              iconProps={{ iconName: "CaretUpSolid8" }}
              title="Priority Up"
              ariaLabel="Priority Up"
              onClick={(event) => handlePriorityUp(event, cell)}
              styles={iconButtonStyles}
            />
            <IconButton
              iconProps={{ iconName: "CaretDownSolid8" }}
              title="Priority Down"
              ariaLabel="Priority Down"
              onClick={(event) => handlePriorityDown(event, cell)}
              styles={iconButtonStyles}
            />
            </div> 
          </div>
        )
      },
    },
    {
      id: "patientDetails",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Patient Details</span>,
      accessor: "patientDetails",
      accessorKey: "patientDetails",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
            <span >
              <div style={{display:"flex", flexDirection:"column"}}>
                <CustomToolTipHost content={`${t("patient.name")}: ${cell.row.original.patientName}`} id={"tooltip_"}>{cell.row.original.patientName}</CustomToolTipHost>
                <CustomToolTipHost  content={`Patient Id : ${cell.row.original.patientId}`} id={"tooltip_"}>P:{`${cell.row.original.patientId}`}</CustomToolTipHost>
                <CustomToolTipHost  content={`Accession Number : ${cell.row.original.accessionNumber}`} id={"tooltip_"}>A:{`${cell.row.original.accessionNumber}`}</CustomToolTipHost>
                <CustomToolTipHost  content={`Order Id : ${cell.row.original.orderId}`} id={"tooltip_"}>O:{`${cell.row.original.orderId}`}</CustomToolTipHost>
              </div>
            </span>
          {/* {cell.row.original.patientId} / {cell.row.original.accessionNumber} / {cell.row.original.orderId} / {cell.row.original.patientName} */}
        </div>
      ),
    },
    {
      id: "createdAt",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Date And Time</span>,
      accessor: "createdAt",
      accessorKey: "createdAt",
      show: true,
      cell: (cell) => (
        <div>
          {cell.row.original.createdAt}
        </div>
      ),
    },
    {
      id: "source",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Firm Name</span>,
      accessor: "firmName",
      accessorKey: "firmName",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
          {cell.row.original.clientName}
        </div>
      ),
    },
    {
      id: "userName",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">User Name</span>,
      accessor: "userName",
      accessorKey: "userName",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
          {cell.row.original.userName}
        </div>
      ),
    },
    {
      id: "studyDescription",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Study Description</span>,
      accessor: "studyDescription",
      accessorKey: "studyDescription",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
          {cell.row.original.studyDescription}
        </div>
      ),
    },
    {
      id: "modality",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Modality</span>,
      accessor: "modality",
      accessorKey: "modality",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
          {cell.row.original.modality}
        </div>
      ),
    },
    {
      id: "destination",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Destination</span>,
      accessor: "destination",
      accessorKey: "destination",
      show: true,
      cell: (cell) => <div className="user-sub-heading">{cell.row.original.destination}</div>,
    },
    {
      id: "status",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Progress</span>,
      accessor: "status",
      accessorKey: "status",
      show: true,
      cell: (cell) => <div className="user-sub-heading">{getStatusIcon(cell.row.original.status)}</div>,
    },
    {
      id: "toatal",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Total</span>,
      accessor: "total",
      accessorKey: "total",
      show: true,
      cell: (cell) => <div className="user-sub-heading">{cell.row.original.total}</div>,
    },
    {
      id: "success",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Success</span>,
      accessor: "success",
      accessorKey: "success",
      show: true,
      cell: (cell) => <div className="user-sub-heading">{cell.row.original.success}</div>,
    },
    {
      id: "actions",
      style: { width: widthStyle },
      headerStyle: {
        padding: paddingChild,
        textAlign: 'left',
        boxSizing: 'border-box',
        width: widthStyle,
      },
      headerClass: 'break-word',
      classChildName: 'break-word',
      header: () => <span className="pacs-list-header-txt">Actions</span>,
      accessor: "action",
      accessorKey: "action",
      show: true,
      cell: (cell) => (
        <div className="user-sub-heading">
          <IconButton
            iconProps={{ iconName: "Refresh" }}
            title="Refresh"
            ariaLabel="Refresh"
            onClick={(event) =>
              handleRefreshQueueItem(event, cell.row.original.id, cell)
            }
            styles={iconButtonStyles}
          />
          <IconButton
            iconProps={{ iconName: "Cancel" }}
            title="Cancel Job"
            ariaLabel="Cancel"
            onClick={(event) =>
              handleCancelQueueItem(event, cell.row.original.id, cell)
            }
            styles={cancelIconButtonStyles}
            style={{ color: 'red' }}
          />
        </div>
      ),
    },
  ];
};
export default ColumnsPacsQueue;